import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { Link, withRouter } from 'react-router-dom'
import '../../../node_modules/bootstrap/scss/bootstrap.scss'
import '../../assets/css/animate.css'
import '../../assets/css/font-awesome.min.css'
import '../../assets/css/responsive.scss'
import '../../assets/css/style.scss'
import logo from '../../assets/images/logo.svg'
import logoBlack from '../../assets/images/logo_black.svg'

class Navigation extends React.Component {
    state = {
        collapsed: true,
        sticky: false,
    };

    toggleNavbar = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        })
    }

    componentDidMount() {
        let elementId = document.getElementById("navbar")
        document.addEventListener("scroll", () => {
            if (window.scrollY > 170) {
                elementId.classList.add("is-sticky")
                this.setState({ sticky: true })
                window.history.pushState("", document.title, window.location.pathname)
            } else {
                elementId.classList.remove("is-sticky")
                this.setState({ sticky: false })
            }
        })
        window.scrollTo(0, 0)

        if (!(window.location.pathname === '/blog' || window.location.pathname === '/blog-details')) {
            let mainNavLinks = document.querySelectorAll("nav ul li a")

            window.addEventListener("scroll", () => {
                let fromTop = window.scrollY

                mainNavLinks.forEach(link => {
                    let section = document.querySelector(link.hash)

                    if (
                        section.offsetTop <= fromTop &&
                        section.offsetTop + section.offsetHeight > fromTop
                    ) {
                        link.classList.add("active")
                    } else {
                        link.classList.remove("active")
                    }
                })
            })
        }
    }

    goToId = (e) => {
        window.location.hash = e
        window.location.refresh(true)
    }

    renderMenus = () => {
        return (
            <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                    <AnchorLink onClick={this.toggleNavbar} offset={() => 85} className="nav-link" href="#home">Home</AnchorLink>
                </li>
                <li className="nav-item">
                    <AnchorLink onClick={this.toggleNavbar} offset={() => 85} className="nav-link" href="#who-we-are">Who we are</AnchorLink>
                </li>
                <li className="nav-item">
                    <AnchorLink onClick={this.toggleNavbar} offset={() => 85} className="nav-link" href="#our-goals">Our Goals</AnchorLink>
                </li>
                <li className="nav-item">
                    <AnchorLink onClick={this.toggleNavbar} offset={() => 85} className="nav-link" href="#our-team">Our Team</AnchorLink>
                </li>
                <li className="nav-item">
                    <AnchorLink onClick={this.toggleNavbar} offset={() => 85} className="nav-link" href="#our-projects">Our Projects</AnchorLink>
                </li>
                <li className="nav-item">
                    <AnchorLink onClick={this.toggleNavbar} offset={() => 85} className="nav-link" href="#about-founder">About The Founder</AnchorLink>
                </li>
                <li className="nav-item">
                    <AnchorLink onClick={this.toggleNavbar} offset={() => 85} className="nav-link" href="#contact">Contacts</AnchorLink>
                </li>
            </ul>
        )
    }

    render() {
        const { collapsed } = this.state
        const classOne = collapsed ? 'collapse navbar-collapse' : 'navbar-collapse collapse show'
        const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right'
        return (
            <nav id="navbar" className="navbar navbar-expand-lg navbar-light bg-light header-sticky">
                <div className="container">
                    <Link
                        className="navbar-brand"
                        to="/"
                        onClick={() => window.location.refresh()}
                    >
                        {this.state.sticky ? <img src={logoBlack} alt="logoblack" /> : <img src={logo} alt="logo" />}
                    </Link>
                    <button
                        onClick={this.toggleNavbar}
                        className={classTwo}
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={classOne} id="navbarSupportedContent">
                        {this.renderMenus()}
                    </div>
                </div>
            </nav>
        )
    }
}

export default withRouter(Navigation)